import * as types from "../constants/action-types";
import { findIndex } from "../utils";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  value: { min: 0, max: 10000 },
  sortBy: "popularity",
  category: [],
  size: [],
  color: [],
  brand: [],
  rating: [],
  filteredProducts: [], // Add filteredProducts property to the initial state
};

function filterReducer(state = initialState, action) {
  switch (action.type) {
    case types.SORT_BY:
      return {
        ...state,
        sortBy: action.sortBy,
      };

    case types.CATEGORY_FILTER:
      const lowercaseCategory = action.category.toLowerCase();
      const category = state.category.slice();
      let index = category.findIndex(
        (item) => item.toLowerCase() === lowercaseCategory
      );

      if (index === -1) {
        category.push(lowercaseCategory);
      } else {
        category.splice(index, 1);
      }

      return {
        ...state,
        category: category,
      };

    case types.RESET_FILTER:
      return {
        ...initialState, // Reset state to the initial state
      };

    case types.SIZE_FILTER:
      let size = [...state.size];
      index = size.findIndex((item) => item === action.size);

      if (-1 === index) {
        // Add the size to the filter
        size.push(action.size);
      } else {
        // Remove the size from the filter
        size.splice(index, 1);
      }

      const filteredProductsSize = state.filteredProducts.filter((product) => {
        if (!product.variants) {
          // No variants, keep the product
          return true;
        }

        const selectedVariant = product.selectedVariant
          ? product.selectedVariant[0]
          : null;
        if (!selectedVariant) {
          // No selected variant, skip the product
          return false;
        }

        const selectedSize = selectedVariant.size
          ? selectedVariant.size[0].name
          : null;
        if (selectedSize && size.includes(selectedSize)) {
          // Variant size matches the selected size filter
          return true;
        }

        return false;
      });

      return {
        ...state,
        size: size,
        filteredProducts: filteredProductsSize,
      };

    case types.COLOR_FILTER:
      let color = Object.assign([], state.color);
      index = findIndex(color, (item) => item === action.color);
      if (-1 === index) {
        color.push(action.color);
      } else {
        color.splice(index, 1);
      }
      return {
        ...state,
        color: color,
      };

    case types.BRAND_FILTER:
      let brand = Object.assign([], state.brand);
      index = findIndex(brand, (item) => item === action.brand);
      if (-1 === index) {
        brand.push(action.brand);
      } else {
        brand.splice(index, 1);
      }
      return {
        ...state,
        brand: brand,
      };

    case types.RATING_FILTER:
      let rating = Object.assign([], state.rating);
      index = findIndex(rating, (item) => item === action.rating);
      if (-1 === index) {
        rating.push(action.rating);
      } else {
        rating.splice(index, 1);
      }
      return {
        ...state,
        rating: rating,
      };

    case types.REFRESH_STORE:
      return { ...initialState }; // Reset state to the initial state

    case types.PRICE_FILTER:
      return {
        ...state,
        value: action.range,
      };

    default:
      return state;
  }
}

const persistConfig = {
  keyPrefix: "liber-",
  key: "filter",
  storage,
};

export default persistReducer(persistConfig, filterReducer);
